import { Form } from '@/components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button, Select } from '@/ui';
import styled from 'styled-components';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: ${COLORS.DARK_ONYX};
  min-height: 100%;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
`;

export const StyledForm = styled(Form)`
  width: 100%;
  min-height: 100%;
`;

export const StyledButton = styled(Button)`
  margin-top: auto;
`;
export const StyledSelect = styled(Select)`
  &&& {
    height: auto !important;

    .ant-select-selection-placeholder {
      color: ${COLORS.BLACK};
    }

    .ant-select-selector {
      overflow: hidden;
      padding-top: 0.15rem;
    }

    .ant-select-selection-overflow {
      white-space: nowrap;

      & .ant-select-selection-overflow-item span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 8vw;
      }

      & .ant-select-selection-overflow-item-rest div {
        border: none;
        color: ${COLORS.GRAY_PRIMARY};
      }

      & .ant-select-selection-overflow-item-suffix {
        padding-left: 0.25rem;
      }
    }

    .ant-select-clear {
      inset-inline-end: 0.25rem;
      top: 50%;
      width: fit-content;
      height: fit-content;
    }
  }
`;
